function setupTorvaneNavigation(root = document) {
 root.querySelectorAll('.tv-mobile-disclosure').forEach(menu => {
  if (menu.dataset.ready) return;
  menu.dataset.ready = 'true';
  const trigger = menu.querySelector('summary');
  const sync = () => trigger.setAttribute('aria-expanded', String(menu.open));
  menu.addEventListener('toggle', sync);
  menu.addEventListener('keydown', event => {
   if (event.key === 'Escape') { event.preventDefault(); menu.open = false; sync(); trigger.focus(); }
  });
  document.addEventListener('click', event => { if (menu.open && !menu.contains(event.target)) { menu.open = false; sync(); } });
  sync();
 });
 root.querySelectorAll('.tv-nav-dropdown').forEach(dropdown => {
  if (dropdown.dataset.ready) return;
  dropdown.dataset.ready = 'true';
  const trigger = dropdown.querySelector('summary');
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const sync = () => trigger.setAttribute('aria-expanded', String(dropdown.open));
  dropdown.addEventListener('mouseenter', () => {
   if (!hover.matches) return;
   document.querySelectorAll('.tv-nav-dropdown[open]').forEach(other => { if (other !== dropdown) other.open = false; });
   dropdown.open = true;
   sync();
  });
  dropdown.addEventListener('mouseleave', () => {
   if (hover.matches && !dropdown.contains(document.activeElement)) { dropdown.open = false; sync(); }
  });
  dropdown.addEventListener('focusout', event => {
   if (!dropdown.contains(event.relatedTarget)) { dropdown.open = false; sync(); }
  });
  dropdown.addEventListener('keydown', event => {
   if (event.key === 'Escape') { event.preventDefault(); dropdown.open = false; sync(); trigger.focus(); }
  });
  dropdown.addEventListener('toggle', sync);
  sync();
 });
}
setupTorvaneNavigation();
document.addEventListener('shopify:section:load', event => setupTorvaneNavigation(event.target));
